module.exports = __webpack_public_path__ + "static/media/kcc.dc6d4be9.png";